import React, { useState } from "react";
import { Button, Card, CardBody, Col, Row } from "reactstrap";
import ContractTypeFilter from "./ContractTypeFilter";
import AgencyFilter from "./AgencyFilter";
import OffCanvasFilter from "./OffCanvasFilter";
import {
  FilterDateRange,
  FilterLabel,
  FilterSearchBox,
} from "Components/Common/TableFilters";

const Filters = ({
  setSearchValue,
  setPage,
  searchValue,
  filterValue,
  setFilterValue,
  setSorted,
}: {
  setSearchValue: (value: string) => void;
  setPage: (page: number) => void;
  searchValue: string;
  filterValue: any;
  setFilterValue: (value: any) => void;
  setSorted: (sorted: any) => void;
}) => {
  const [advancedFilter, setAdvancedFilter] = useState(false);

  return (
    <Card>
      <CardBody>
        <Row className="g-3 align-items-end">
          <Col xxl={4} lg={6}>
            <FilterSearchBox
              id="contract-search"
              placeholder="Search contracts..."
              value={searchValue}
              onChange={(value: string) => {
                setSearchValue(value);
                setPage(1);
              }}
            />
          </Col>
          <Col xxl={2} lg={6}>
            <FilterLabel htmlFor="contractTypeFilter">
              Contract Type
            </FilterLabel>
            <ContractTypeFilter
              onChange={(value) => {
                setFilterValue({ ...filterValue, contractType: value });
                setPage(1);
              }}
              value={filterValue.contractType}
            />
          </Col>
          <Col xxl={3} lg={6}>
            <FilterDateRange
              id="contract-date-range"
              value={filterValue?.dateRange}
              onChange={(dateRange: any) => {
                setFilterValue({ ...filterValue, dateRange });
                setPage(1);
              }}
            />
          </Col>
          <Col xxl={2} lg={6}>
            <FilterLabel htmlFor="agencyFilter">Agency</FilterLabel>
            <AgencyFilter
              onChange={(value) => {
                setFilterValue({ ...filterValue, agency: value });
                setPage(1);
              }}
              value={filterValue.agency}
            />
          </Col>
          <Col xxl={1} lg="auto">
            <Button
              color="light"
              onClick={() => {
                setAdvancedFilter(true);
              }}
            >
              <i className="ri-equalizer-line align-bottom me-1"></i>
              More
            </Button>
          </Col>
        </Row>
      </CardBody>
      <OffCanvasFilter
        show={advancedFilter}
        onCloseClick={() => setAdvancedFilter(false)}
        setFilterValue={setFilterValue}
        filterValue={filterValue}
        setPage={setPage}
        setSearchValue={setSearchValue}
        searchValue={searchValue}
      />
    </Card>
  );
};

export default Filters;
